import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TalentPoolRoutingModule } from './talent-pool-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TalentPoolRoutingModule
  ]
})
export class TalentPoolModule { }
